import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useGetBondRiskAssessmentFormSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(queryKey, async () =>
    await SchemaService.getBondRiskAssessmentSchema()
  );

  return {
    bondRiskAssessmentSchema: data?.data?.schema,
    isBondRiskAssessmentSchemaLoading: isLoading,
    bondRiskAssessmentSchemaError: error,
    isBondRiskAssessmentSchemaError: isError, 
    fetchBondRiskAssessmentSchema: refetch
  }
}